import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'number-5', 'IconNumber5', [["path",{"d":"M8 20h4a4 4 0 1 0 0 -8h-4v-8h8","key":"svg-0"}]]);